import { t } from "@web-monorepo/i18n/macro";

export type ErrorType = "NotSupportedError" | "NotFoundError" | "NotAllowedError" | "UnknownError";

export default (errorType: string) => {
  switch (errorType) {
    case "NotSupportedError":
      return t`Noise Meter is not supported in this browser. Try using Chrome or Firefox.`;
    case "NotFoundError":
      return t`No microphone was found on your computer.`;
    case "NotAllowedError":
      return t`To use Noise Meter, please allow use of the microphone in your browser’s settings.`;
    case "UnknownError":
      return t`An unknown error occurred.`;
  }
};
